var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "white sidebar",
      attrs: {
        fixed: "",
        permanent: "",
        "mini-variant": true,
        "mini-variant-width": 60
      }
    },
    [
      _c(
        "div",
        { staticClass: "person-selector-container" },
        _vm._l(_vm.people, function(person) {
          return _c(
            "div",
            {
              key: person.fName + person.lName,
              class: [
                person === _vm.selectedPerson ? "selected-person" : "",
                "person"
              ],
              on: {
                click: function($event) {
                  return _vm.selectPerson(person)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "person-image-holder temp-name-container" },
                [
                  _c("img", {
                    staticClass: "person-image",
                    attrs: {
                      src: "https://cdn.vuetifyjs.com/images/cards/road.jpg"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "temp-name-text" }, [
                    _vm._v(_vm._s(person.fName))
                  ])
                ]
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3570c818", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3570c818","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/People/PersonSelector.vue
// module id = 0G7d
// module chunks = 1